import { ThemeProvider, createTheme } from '@mui/material';
import { FC, ReactNode } from 'react';
import globalColors from './globalColors';

interface ThemeProps {
    children: ReactNode;
}

const Theme: FC<ThemeProps> = ({ children }: ThemeProps) => {
    const theme = createTheme({
        palette: {
            primary: {
                main: globalColors.backgrounds.purple,
                light: '#A588D2',
                dark: '#A588D2'
            }
        },
        components: {
            MuiCheckbox: {
                styleOverrides: {
                    root: {
                        color: '#716596 !important'
                    }
                }
            },
            MuiInputBase: {
                styleOverrides: {
                    root: {
                        display: 'flex',
                        padding: '0.25rem 15.9375rem 0.25rem 0.25rem !important',
                        alignItems: 'center !important',
                        gap: '0.25rem !important',
                        flex: '1 0 0',
                        borderRadius: '0.25rem !important',
                        border: '1px solid rgba(226, 216, 247, 0.40) !important',
                        background: '#FFF',
                        backdropFilter: 'blur(10px)',
                        '& .MuiChip-root': {
                            marginRight: '0px !important'
                        }
                    }
                }
            },

            MuiButtonBase: {
                styleOverrides: {
                    root: {
                        padding: '0px !important'
                    }
                }
            }
        }
    });
    return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
export default Theme;
